import { render, staticRenderFns } from "./realTimeBusBox.vue?vue&type=template&id=29475756&scoped=true"
import script from "./realTimeBusBox.vue?vue&type=script&lang=js"
export * from "./realTimeBusBox.vue?vue&type=script&lang=js"
import style0 from "./realTimeBusBox.vue?vue&type=style&index=0&id=29475756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29475756",
  null
  
)

export default component.exports